import styled from 'styled-components';
import { Flex } from '@amzn/storm-ui';

export const PageNavigationFlex = styled(Flex)`
  margin-top: 1rem;
  justify-content: right;
`;
